import React, { useState, useEffect } from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { APIClient } from '../../helpers/api_helper';

const APIUsageChart = () => {
    const [chartData, setChartData] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const [days, setDays] = useState(7);
    const apiClient = new APIClient();

    useEffect(() => {
        fetchAPIUsageData();
    }, [days]);

    const fetchAPIUsageData = async () => {
        try {
            setLoading(true);
            const response: any = await apiClient.get(`/dashboard/api-usage-chart?days=${days}`);

            if (response.code === 200 && response.data) {
                setChartData(response.data);
            }
        } catch (error) {
            console.error('Error fetching API usage chart:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Card>
            <CardHeader className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center gap-2">
                    <h5 className="card-title mb-0">API Usage</h5>
                    <span className="badge bg-success-subtle text-success">
                        <span className="me-1">🟢</span> Production
                    </span>
                </div>
                <div className="btn-group btn-group-sm" role="group">
                    <button
                        type="button"
                        className={`btn ${days === 7 ? 'btn-primary' : 'btn-light'}`}
                        onClick={() => setDays(7)}
                    >
                        7 Days
                    </button>
                    <button
                        type="button"
                        className={`btn ${days === 30 ? 'btn-primary' : 'btn-light'}`}
                        onClick={() => setDays(30)}
                    >
                        30 Days
                    </button>
                    <button
                        type="button"
                        className={`btn ${days === 90 ? 'btn-primary' : 'btn-light'}`}
                        onClick={() => setDays(90)}
                    >
                        90 Days
                    </button>
                </div>
            </CardHeader>
            <CardBody>
                {loading ? (
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                ) : chartData ? (
                    <div className="text-center">
                        {/* Chart will be rendered here - integrate with chart library */}
                        <p className="text-muted">Chart data loaded. Integrate with charting library.</p>
                        <pre className="text-start">{JSON.stringify(chartData, null, 2)}</pre>
                    </div>
                ) : (
                    <div className="text-center text-muted">No data available</div>
                )}
            </CardBody>
        </Card>
    );
};

export default APIUsageChart;
